import React from "react";

const GuideTypeFormGroup = (props) => {

    const handleSetTypes = (type, index) => {
        const newArr = [...props.selectedTypes]
        newArr[index] = type
        props.setTypes(newArr.filter(t => t.length > 0)) // removes unused types
    }
    const handleAddType = (e) => {
        e.preventDefault()
        const newArr = [...props.selectedTypes]
        newArr.push("")
        props.setTypes(newArr)
    }

    return (    
        <div className="form-group">
            <label>Guide Types</label>
            {props.selectedTypes.map((type,i) => (
                <select style={{margin: '0.3rem 0'}} name="type" data={type} key={`selected-type-${i}`} value={type} onChange={(e) => handleSetTypes(e.target.value, i)} >
                    <option value="">Select Types</option>
                    {props.guideTypes.map((t,i) => (
                        <option key={`type-${i}`} value={t.hyphenated_title}>{t.title}</option>
                    ))}
                </select>
            ))}
            <button className="manage-item-action add-input" onClick={handleAddType}>+</button>
        </div>
    )
}

export default GuideTypeFormGroup;